import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Logo from "../../assets/logo.png";
import PartnerLogo from "../../assets/iraqi-family-physicians-society-logo.png";
import { CONSULTATION_REGISTRATION } from "../../config/appConfig";
// import { Link } from "react-router-dom";

const Header = () => {
  // The consultation registration link carries the partner logo and the Tiryaq Professional
  // title; the main page keeps the standard header and tab title.
  const isConsultationRegistration =
    useLocation().pathname.replace(/\/+$/, "") === CONSULTATION_REGISTRATION.ROUTE;

  useEffect(() => {
    if (!isConsultationRegistration) return undefined;
    const previousTitle = document.title;
    document.title = CONSULTATION_REGISTRATION.TITLE;
    return () => {
      document.title = previousTitle;
    };
  }, [isConsultationRegistration]);

  return (
    <header className="header">
      <div className="logo-section">
        <div className="logo">
            <img src={Logo} alt="Logo" width={250} />
        </div>
      </div>
      <div className="header-actions">
        {isConsultationRegistration && (
          <img
            className="partner-logo"
            src={PartnerLogo}
            alt="Iraqi Family Physicians Society"
          />
        )}
        {/* <button className="help-btn">
          <HelpCircle size={16} />
          Help
        </button> */}
      </div>
    </header>
  );
};

export default Header;
